import { ReportingGroupListEntry, ReportingGroup } from './reporting-group-administration.model';
import { Identity } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';

@Injectable({
  providedIn: 'root'
})
export class ReportingGroupAdministrationService {

  constructor(private httpService: HttpService) { }

  public getReportinGroupListEntries(): Observable<ReportingGroupListEntry[]> {
    return this.httpService.postWithContext<ReportingGroupListEntry[]>(environment.reportingGroupAdminEndpoint, {});
  }

  public getReportinGroup(reportingGroupId: number): Observable<ReportingGroup> {
    return this.httpService.postWithContext<ReportingGroup>(environment.reportingGroupAdminEndpoint + '/reporting-group', reportingGroupId);
  }

  public saveReportingGroup(details: ReportingGroup): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.reportingGroupAdminEndpoint + '/save', details);
  }

  public deleteReportingGroup(reportingGroupId: number): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.reportingGroupAdminEndpoint + '/delete', reportingGroupId);
  }
}
